import { ListPageLayout } from "@/components/list-page-layout";
import { usePageTitle } from "@/hooks/use-page-title";
import { CampaignsDataTable } from "./campaigns-data-table";

export default function CampaignListView() {
  usePageTitle("Campaign List");

  return (
    <ListPageLayout pageType="campaigns::list" title="Campaign List">
      <CampaignsDataTable />
    </ListPageLayout>
  );
}
